import { ComponentChildren, h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./RightPanelBasicCell.module.css";

type Props = {
    class?: string;
    title?: string;
    content?: ComponentChildren;
    contentClass?: string;
    rightContent?: ComponentChildren;
    displayRightContentOnHover?: boolean;
};

function RightPanelBasicCell({
    class: cssClass,
    title,
    content,
    contentClass,
    rightContent,
    displayRightContentOnHover = false
}: Props) {
    return (
        <div class={classname(
            styles.rightPanelBasicCell,
            cssClass,
            "body-1",
            { [styles.displayRightContentOnHover]: displayRightContentOnHover })}>
            <div class={classname(styles.leftContainer, "ellipsis")}>
                {title && (
                    <span class={styles.title}>
                        {title}
                    </span>
                )}
                {content && (
                    <span class={classname(styles.content, contentClass, "ellipsis")}>
                        {content}
                    </span>
                )}
            </div>
            {rightContent && (
                <div class={styles.rightContentContainer}>
                    {rightContent}
                </div>
            )}
        </div>
    );
}

export default RightPanelBasicCell;
export { Props as RightPanelBasicCellProps };
